import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";

interface IHitMapSearchParams {
    action: "apply" | "open" | "close";
    regionName: string;
    eventName?: string;
    openFromLabel?: string | null;
}

export function hitMapSearch(params: IHitMapSearchParams) {
    const {action, regionName, eventName, openFromLabel} = params;

    hitGoogleTagManager({
        event: eventName || "map_search",
        event_action: action,
        event_category: regionName,
        ...(openFromLabel ? {custom_label: openFromLabel} : {})
    });
}
import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";

interface IHitMapSearchParams {
    action: "apply" | "open" | "close";
    regionName: string;
    eventName?: string;
    openFromLabel?: string | null;
}

export function hitMapSearch(params: IHitMapSearchParams) {
    const {action, regionName, eventName, openFromLabel} = params;

    hitGoogleTagManager({
        event: eventName || "map_search",
        event_action: action,
        event_category: regionName,
        ...(openFromLabel ? {custom_label: openFromLabel} : {})
    });
}
